import { all, call, put, takeEvery, select } from 'redux-saga/effects';
import { withApiErrorHandling } from '../helpers/sagaHelper';
import { getPropertySuccess } from '../actions/propertyActions';
import * as types from '../actions/actionType';
import session from 'containers/App/session';
import { statsService } from 'utils/api';

export function* getPropertyByYear(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* getYearViewData() {
        const apiDateFormat = 'YYYY-MM-DD';
        const startDate = action.startDate.format(apiDateFormat);
        const endDate = action.endDate.format(apiDateFormat);
        const lyStartDate = action.lyStartDate.format(apiDateFormat);
        const lyEndDate = action.lyEndDate.format(apiDateFormat);

        const [yearStats, budgetData, lastYearStats] = yield all([
            call(statsService({ token, propertyId: action.id }).getFinalRoomsAndRevenueByDay, {
                start: startDate,
                end: endDate,
            }),
            call(statsService({ token, propertyId: action.id }).getBudgetByMonth, {
                start: startDate,
                end: endDate,
            }),
            call(statsService({ token, propertyId: action.id }).getLySpitRoomsAndRevenueByMonth, {
                start: lyStartDate,
                end: lyEndDate,
            }),
        ]);

        const response = {
            data: yearStats.data,
            budget: budgetData.data,
            lySpit: lastYearStats.data,
        };
        yield put(getPropertySuccess(types.GET_PROPERTY_BY_YEAR_SUCCESS, response));
    });
}

export function* watchGetPropertyByYear() {
    yield takeEvery(types.GET_PROPERTY_BY_YEAR, getPropertyByYear);
}
